import { StyleSheet } from 'react-native';
export default function createThemedStyle(generator) {
    return (themedStyleOptions, props) => StyleSheet.create(generator(themedStyleOptions, props));
}
